import { render } from "./ReleasesBase.vue?vue&type=template&id=77b4478a"
import script from "./ReleasesBase.vue?vue&type=script&lang=js"
export * from "./ReleasesBase.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./ReleasesBase.vue?vue&type=style&index=0&id=77b4478a&module=true&lang=css"
cssModules["$style"] = style0

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__